import config from "../config";
import {
  User,
  UserCredential,
  UserRequestOtp,
  UserResetPassword,
  UserLogin,
  AuthenticationEnable,
} from "../Model/User";
import {
  sendPostRequest,
  sendPostRequestReturnValue,
  concatOptionalParameter,
  sendGetRequest,
  sendPutRequest,
  sendDeleteRequest,
} from "../Utility/FetchUtils";

export default class UserApi {
  static BASE_URL = config.SERVICE_URL + "/User";

  static getUsersLoggedIn() {
    let url = this.BASE_URL + "/logged-in";
    return sendGetRequest<User[]>(url);
  }

  static authenticate(userName: string, password: string) {
    const url = this.BASE_URL + "/:authenticate";
    const body = {
      userName: userName,
      password: password,
    };

    return sendPostRequestReturnValue<UserCredential>(url, body);
  }

  static login(user: UserCredential) {
    let url = this.BASE_URL + "/logged-in";

    return sendPutRequest(url, user);
  }

  static logout() {
    const url = this.BASE_URL + "/:logout";

    return sendPostRequest(url);
  }

  static getUsers(
    isActive: boolean | null = null,
    userName: string | null = null,
    userEmail: string | null = null,
    name: string | null = null,
    surname: string | null = null,
    userRole: string | null = null
  ) {
    let url = this.BASE_URL;
    url = concatOptionalParameter(url, {
      "is-active": isActive,
      "user-name": userName,
      "user-email": userEmail,
      "user-role": userRole,
      name: name,
      surname: surname,
    });

    return sendGetRequest<User[]>(url);
  }

  static createUser(user: User) {
    let url = this.BASE_URL + "/:create";

    return sendPostRequest(url, user);
  }

  static updateUser(user: User) {
    let url = this.BASE_URL;

    return sendPutRequest(url, user);
  }

  static removeUser(user: User) {
    let url = this.BASE_URL;

    return sendDeleteRequest(url, user);
  }

  static updateSelfPassword(oldPassword: string, newPassword: string) {
    let url = this.BASE_URL + "/password";
    const body = {
      oldPassword: oldPassword,
      newPassword: newPassword,
    };
    return sendPutRequest(url, body);
  }

  static refreshToken(userCredential: UserCredential) {
    const url = this.BASE_URL + "/:refresh-token";
    const body = userCredential;

    return sendPostRequestReturnValue<UserCredential>(url, body);
  }

  static requestOtp(userCredential: UserRequestOtp) {
    const url = this.BASE_URL + "/request-otp";
    const body = userCredential;

    return sendPutRequest(url, body);
  }

  static resetPassword(resetPassword: UserResetPassword) {
    const url = this.BASE_URL + "/reset-password";
    const body = resetPassword;

    return sendPutRequest(url, body);
  }

  static generateOtp(user: string, adminUserLogin: UserLogin) {
    const url = this.BASE_URL + "/generate-otp" + "/" + user;
    const body = adminUserLogin;

    return sendPutRequest(url, body);
  }

  static isAuthenticationEnable() {
    const url = this.BASE_URL + "/:is-authentication-enable";
    return sendGetRequest<AuthenticationEnable>(url);
  }

  static getUserCredential(user: string) {
    const url = this.BASE_URL + "/:user-credential" + "/" + user;
    return sendGetRequest<UserCredential>(url);
  }
}
